
class FbdClassInvitePanel {
   copyButton = undefined;
   buttonListener;
   eGui;
   invCode;

   codeElemId;

   init(params) {
      this.invCode = params.value;

      this.codeElemId = `invitecode-${params.data['class_id']}`;

      const nowDate = new Date();
      const codeExpiry = new Date(params.data['code_expiry']);

      this.eGui = document.createElement('span');

      this.eGui.classList.add('class-title');

      const codeLabel = document.createElement('div');
      codeLabel.id = this.codeElemId;
      codeLabel.classList.add('roster-invite-code');
      codeLabel.innerText = this.invCode;

      this.eGui.appendChild(codeLabel);

      if(nowDate.getTime() > codeExpiry.getTime()) {
         codeLabel.classList.add('expired')

         const expMsg = document.createElement('span');
         expMsg.classList.add('roster-expired-text');
         expMsg.innerText = "⚠ This code has expired.";

         this.eGui.appendChild(expMsg);
      }
      else {
         this.copyButton = document.createElement('button');
         this.copyButton.classList.add('copy-button');
         this.buttonListener = this.buttonClicked.bind(this);

         this.copyButton.addEventListener('click', this.buttonListener);

         const copyButtonInner = document.createElement('span');
         copyButtonInner.classList.add('material-icons');
         copyButtonInner.textContent = 'content_copy';

         this.copyButton.appendChild(copyButtonInner);

         this.eGui.appendChild(this.copyButton);
      }
   }

   async buttonClicked() {
      try {
         await navigator.clipboard.writeText(this.invCode);
         alert("Code copied to clipboard!");
      } catch (err) {
         alert(`Failed to copy code: ${err}`);
      }
   }

   getGui() {
      return this.eGui;
   }

   refresh(params) {
      return false;
   }

   destroy() {
      if(this.copyButton) {
         this.copyButton.removeEventListener('click', this.buttonListener);
      }
   }
}

export default FbdClassInvitePanel;